<template>
  <v-dialog v-model="isOpen" max-width="900px" scrollable>
    <v-card>
      <v-card-title class="justify-center" cols="12">
        <h2>
          Просмотр и редактирование анкеты
        </h2>
      </v-card-title>
      <v-card-text style="height: 85%;">
        <v-col
            cols="12"
        >
          <ValidationObserver ref="validationObserver" v-slot="{ handleSubmit }">
            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="имя"
                    rules="required"
                >
                  <v-text-field
                      v-model="questionnaire.name"
                      :error-messages="errors"
                      label="Имя"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="предоставленная услуга"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.service_provided"
                      :error-messages="errors"
                      :items="serviceProviders"
                      label="Предоставленная услуга"
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="обращение"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.primacy"
                      :error-messages="errors"
                      :items="primacyTypes"
                      label="Обращение"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="кто обратился"
                    rules="required"
                >
                  <v-text-field
                      v-model="questionnaire.who_called"
                      :error-messages="errors"
                      label="Кто обратился?"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="пол"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.gender"
                      :error-messages="errors"
                      :items="['муж', 'жен']"
                      label="Пол"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="возраст"
                    rules="required|numeric"
                >
                  <v-text-field
                      v-model="questionnaire.age"
                      :error-messages="errors"
                      label="Возраст"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="семейное положение"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.marital_status"
                      :error-messages="errors"
                      :items="maritalStatuses"
                      label="Семейное положение"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="национальность"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.nationality"
                      :error-messages="errors"
                      :items="nationalities"
                      label="Национальность"
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="образование"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.education"
                      :error-messages="errors"
                      :items="educations"
                      label="Образование"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="социальный статус"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.social_status"
                      :error-messages="errors"
                      :items="socialStatuses"
                      label="Социальный статус"
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="место рождения"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.place_of_birth_type"
                      :error-messages="errors"
                      :items="placeOfBirthTypes"
                      label="Место рождения (Тип населенного пункта)"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  v-if="questionnaire.place_of_birth_type === placeOfBirthTypes[0] || questionnaire.place_of_birth_type === placeOfBirthTypes[1]"
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="место рождения"
                    rules="required"
                >
                  <v-text-field
                      v-model="questionnaire.place_of_birth"
                      :error-messages="errors"
                      label="Место рождения (Названия насленного пункта)"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="причина обращения"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.petition_reason"
                      :error-messages="errors"
                      :items="petitionReasons"
                      label="Причина обращения"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  v-if="questionnaire.petition_reason === petitionReasons[5].value"
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="причина обращения"
                    rules="required"
                >
                  <v-text-field
                      v-model="questionnaire.petition_reason_other"
                      :error-messages="errors"
                      label="Причина обращения (Если выбрано другое)"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                  v-if="questionnaire.petition_reason === petitionReasons[3].value"
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="торговля людьми"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.human_trafficking_type"
                      :error-messages="errors"
                      :items="humanTraffickingTypes"
                      label="Торговля людьми (Тип)"
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row
                v-if="questionnaire.petition_reason === petitionReasons[0].value"
            >
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="Домашнее насилие"
                    rules="required"
                >
                  <v-select
                      v-model="questionnaire.domestic_violence_type"
                      :error-messages="errors"
                      :items="domesticViolenceTypes"
                      label="Домашнее насилие (Выберите другое если нет в списке)"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                  v-if="questionnaire.domestic_violence_type === domesticViolenceTypes[5].value"
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="Домашнее насилие"
                    rules="required"
                >
                  <v-text-field
                      v-model="questionnaire.domestic_violence_other"
                      :error-messages="errors"
                      label="Домашнее насилие (Если выбрано другое)"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-textarea
                v-model="questionnaire.description"
                label="Описание проблемы"
            ></v-textarea>

            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <v-checkbox
                    v-model="questionnaire.asylum"
                    label="Предоставлено убежище"
                ></v-checkbox>
              </v-col>
              <v-col
                  sm="6"
                  cols="12"
              >
                <v-checkbox
                    v-model="questionnaire.hot_line"
                    label="Оказана помощь по телефону"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  sm="6"
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="как нас нашли"
                    rules="required"
                >
                  <v-text-field
                      v-model="questionnaire.how_find"
                      :error-messages="errors"
                      label="Как нас нашли?"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-btn color="red darken-1" text @click="deleteQuest()">
                Удалить анкету
              </v-btn>
              <v-spacer />

              <v-btn color="blue darken-1" text @click="close">
                Закрыть
              </v-btn>

              <v-btn
                  color="primary"
                  @click.prevent="handleSubmit(save)"
              >
                Сохранить
              </v-btn>
            </v-row>
          </ValidationObserver>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import serviceProviders from '../enum/serviceProvided'
import primacyTypes from '../enum/primacyTypes'
import maritalStatuses from '../enum/maritalStatuses'
import nationalities from '../enum/nationalities'
import educations from '@/enum/educations'
import socialStatuses from '@/enum/socialStatuses'
import placeOfBirthTypes from '@/enum/placeOfBirthTypes'
import petitionReasons from '@/enum/petitionReasons'
import humanTraffickingTypes from '@/enum/humanTraffickingTypes'
import domesticViolenceTypes from '../enum/domesticViolenceTypes'

export default {
  name: 'Main',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: Boolean,
    questionnaire: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data () {
    return {
      serviceProviders: serviceProviders,
      primacyTypes: primacyTypes,
      maritalStatuses: maritalStatuses,
      nationalities: nationalities,
      educations: educations,
      socialStatuses: socialStatuses,
      placeOfBirthTypes: placeOfBirthTypes,
      petitionReasons: petitionReasons,
      humanTraffickingTypes: humanTraffickingTypes,
      domesticViolenceTypes: domesticViolenceTypes,
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.value
      },
      set (value) {
        // this.$validator.reset()
        this.$emit('input', value)
      },
    },
  },
  methods: {
    close () {
      this.isOpen = false
      this.$emit('on-close')
    },
    async deleteQuest () {
      await this.$store.dispatch('questionnaires/delete', this.questionnaire)
      this.isOpen = false
      this.$emit('on-save', this.item)
    },
    async save() {
      await this.$store.dispatch('questionnaires/update', this.questionnaire)
      this.isOpen = false
      this.$emit('on-save', this.item)
    }
  }
}
</script>

<style scoped>

</style>
